import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges } from '@angular/core';
import { AudiPlatformProvider, Checkbox } from '@audi/audi-ui-react';
import React from 'react';
import ReactDOM from 'react-dom';

@Component({
    selector: 'app-audi-checkbox',
    template: ''
})
export class AudiCheckboxComponent implements AfterViewInit, OnChanges, OnDestroy {
    //https://react.ui.audi/?path=/story/components-checkbox-overview--page
    @Input() inputId = '';
    @Input() label = '';
    @Input() checked = false;
    @Input() required = true;
    @Output() checkedChange = new EventEmitter<boolean>();

    ElementToShow = () => (
        <AudiPlatformProvider>
            <Checkbox
                inputId={this.inputId}
                checked={this.checked}
                required={this.required}
                className='audi-checkbox'
                onChange={this.handleChange}>
                {this.label}
            </Checkbox>
        </AudiPlatformProvider>
    );

    constructor(private hostRef: ElementRef) {
        this.handleChange = this.handleChange.bind(this);
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.render();
    }

    ngAfterViewInit(): void {
        this.render();
    }

    ngOnDestroy(): void {
        ReactDOM.unmountComponentAtNode(this.hostRef.nativeElement);
    }

    private render() {
        ReactDOM.render(<this.ElementToShow />, this.hostRef.nativeElement);
    }

    public handleChange(event: any): void {
        //console.log('handleChange');
        this.checked = !this.checked;
        //console.log(this.checked);
        this.checkedChange.emit(this.checked);
        this.render();
    }
}
